module.exports = "img/micro.27b02e.jpg";